import { useEffect, useState } from "react";
import { getAllCategory } from "../../../../Admin/helper";
import LoggedInNavbar from "../../../../Admin/helper/loggedInNavbar";
import { isAuthenticated } from "../../../../Auth/helper";
import { uploadmediafile } from "../../../index";
import { useNavigate } from "react-router-dom";

const AddVideo = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [uploadmedia, setupload] = useState({
    productName: "",
    categoryId: "0",
    subCategoryId: "0",
    description: null,
    captionType: "None", // ← new field, video-only
  });

  const [subCatgory, setSubCategory] = useState([]);
  const [uploadafile, setuploadfile] = useState(null);
  const [uploadThumbNailfile, setuploadThumbNailfile] = useState(null);
  const [getallcat, setallcat] = useState([]);

  const { productName, categoryId, description, subCategoryId, captionType } =
    uploadmedia;

  useEffect(() => {
    const currentdetails = isAuthenticated();
    const getcat = async () => {
      await getAllCategory(currentdetails.user._id, currentdetails.token)
        .then((re) => {
          setallcat(re.allCategory);
          setSubCategory(re.allsubCategory);
        })
        .catch(console.log);
    };
    getcat();
  }, []);

  const handleformfield = (name) => (e) => {
    setupload({ ...uploadmedia, [name]: e.target.value });
  };

  const handlesubmit = async (e) => {
    e.preventDefault();

    // ✅ FIX: proper validation
    if (!productName || categoryId === "0" || subCategoryId === "0") {
      alert("All fields are mandatory");
      return;
    }

    if (!uploadafile) {
      alert("Please select a video file");
      return;
    }

    setLoading(true);

    const newform = new FormData();

    // ✅ FIX: only append if exists (NO null)
    newform.append("myfile", uploadafile);

    if (uploadThumbNailfile) {
      newform.append("myfile1", uploadThumbNailfile);
    }

    newform.append("productName", productName);
    newform.append("categoryId", categoryId);
    newform.append("subCategoryId", subCategoryId);

    if (description) {
      newform.append("description", description);
    }

    newform.append("captionType", captionType);

    // ✅ DEBUG (very useful)
    for (let pair of newform.entries()) {
      console.log(pair[0], pair[1]);
    }

    const cur = isAuthenticated();

    await uploadmediafile(cur.user._id, cur.token, categoryId, newform)
      .then((ret) => {
        console.log("RESPONSE:", ret);

        if (ret.message) {
          alert(ret.message);

          setupload({
            productName: "",
            categoryId: "0",
            subCategoryId: "0",
            description: "",
            captionType: "None",
          });

          setuploadfile(null);
          setuploadThumbNailfile(null);
        } else if (ret.error) {
          alert(ret.error);
        } else {
          alert("Unknown response from server");
        }
      })
      .catch((err) => {
        console.log(err);
        alert("Error in sending request");
      })
      .finally(() => setLoading(false));
  };

  // ── Styles (unchanged from original) ─────────────────────────────────────
  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    marginBottom: "20px",
  };
  const headerStyle = {
    backgroundColor: "#f8f9fa",
    color: "#2c3e50",
    borderBottom: "2px solid #e9ecef",
    padding: "16px 20px",
    borderRadius: "12px 12px 0 0",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const backButtonStyle = {
    backgroundColor: "#6c757d",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "14px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  };
  const formGroupStyle = { marginBottom: "20px" };
  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#495057",
    fontSize: "14px",
  };
  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: "#ffffff",
    boxSizing: "border-box",
  };
  const selectStyle = { ...inputStyle, cursor: "pointer" };
  const textareaStyle = {
    ...inputStyle,
    resize: "vertical",
    minHeight: "100px",
  };
  const fileInputStyle = { ...inputStyle, padding: "8px 16px" };
  const buttonStyle = {
    backgroundColor: "#28a745",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  return (
    <>
      <LoggedInNavbar />
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
        }}
      >
        <div className="container">
          <div style={cardStyle}>
            <div style={headerStyle}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="fas fa-video me-2"></i>
                Upload Videos
              </div>
              <button
                style={backButtonStyle}
                onClick={() => navigate("/adminDashboard")}
              >
                <i className="fas fa-arrow-left"></i>
                Back
              </button>
            </div>

            <div style={{ padding: "24px" }}>
              <form onSubmit={handlesubmit}>
                {/* Row 1 — files */}
                <div className="row">
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-file-video me-2"></i>Select Video
                        File
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="myfile"
                        onChange={(e) => setuploadfile(e.target.files[0])}
                        accept="video/*"
                        style={fileInputStyle}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-image me-2"></i>Select Thumbnail
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="myfile1"
                        accept="image/*"
                        onChange={(e) =>
                          setuploadThumbNailfile(e.target.files[0])
                        }
                        style={fileInputStyle}
                      />
                    </div>
                  </div>
                </div>

                {/* Row 2 — name + media type */}
                <div className="row">
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-tag me-2"></i>Media Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="productName"
                        value={productName}
                        onChange={handleformfield("productName")}
                        placeholder="Enter video name"
                        style={inputStyle}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-list me-2"></i>Media Type
                      </label>
                      <select
                        className="form-select"
                        value={categoryId}
                        onChange={handleformfield("categoryId")}
                        style={selectStyle}
                        required
                      >
                        <option value="0">Select Media type</option>
                        {getallcat.map((i) => (
                          <option key={i._id} value={i._id}>
                            {i.categoryName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                {/* Row 3 — sub type + description */}
                <div className="row">
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-layer-group me-2"></i>Media Sub
                        Type
                      </label>
                      <select
                        className="form-select"
                        value={subCategoryId}
                        onChange={handleformfield("subCategoryId")}
                        style={selectStyle}
                        required
                      >
                        <option value="0">Select Media Sub type</option>
                        {subCatgory.map((i) => (
                          <option key={i._id} value={i._id}>
                            {i.subCategoryName}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-align-left me-2"></i>Description
                      </label>
                      <textarea
                        className="form-control"
                        rows="3"
                        value={description || ""}
                        name="description"
                        onChange={handleformfield("description")}
                        placeholder="Enter video description"
                        style={textareaStyle}
                      />
                    </div>
                  </div>
                </div>

                {/* ── Row 4 — Caption Language (video-only field) ──────────── */}
                <div className="row">
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-closed-captioning me-2"></i>
                        Caption Language
                        <span
                          style={{
                            marginLeft: 8,
                            fontSize: 11,
                            color: "#6c757d",
                            fontWeight: 400,
                            backgroundColor: "#e9ecef",
                            padding: "2px 7px",
                            borderRadius: 10,
                          }}
                        >
                          Videos only
                        </span>
                      </label>
                      <select
                        className="form-select"
                        value={captionType}
                        onChange={handleformfield("captionType")}
                        style={{
                          ...selectStyle,
                          borderColor:
                            captionType !== "None" ? "#28a745" : "#e0e0e0",
                          // subtle green border when a language is selected
                        }}
                      >
                        <option value="None">None / Not Applicable</option>
                        <option value="Hindi">🇮🇳 Hindi Captioned</option>
                        <option value="English">🌐 English Captioned</option>
                      </select>
                      {captionType !== "None" && (
                        <small
                          style={{
                            color: "#28a745",
                            marginTop: 4,
                            display: "block",
                          }}
                        >
                          ✓ Video will appear under "{captionType} Captioned"
                          tab
                        </small>
                      )}
                    </div>
                  </div>
                  {/* col-md-6 intentionally left empty to keep layout balanced */}
                  <div className="col-md-6" />
                </div>

                {/* Submit */}
                <div style={{ marginTop: "24px", textAlign: "center" }}>
                  <button
                    className="btn"
                    disabled={loading}
                    type="submit"
                    style={{
                      ...buttonStyle,
                      backgroundColor: loading ? "#6c757d" : "#28a745",
                      cursor: loading ? "not-allowed" : "pointer",
                    }}
                  >
                    {loading ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i>
                        Uploading Video...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-upload"></i>
                        Upload Video
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddVideo;
